<template lang="pug">
	.comentarios
		.titular
			span.fa.fa-comments.mr-2
			| Comentarios
		.comentario(
			v-for="coment in comentarios"
			:key="coment.ComentarioID"
		)
			.cabecera
				.usuario {{coment.UsuarioNombre}}
				.fecha {{coment.FechaComentarioUnix | moment('D-M-Y')}} a las {{coment.FechaComentarioUnix | moment('HH:mm:ss')}}
			.texto {{coment.Comentario}}
		div.bg-dark.text-white(v-if="hayMas")
			span.verTodos(@click="verTodos = !verTodos")
				span.fa.fa-caret-down.mr-2
				| Ver todos los comentarios
		.formulario
			div.input-group
				input.form-control(style="border-radius: 0;border: 0;border-top: 1px solid #e0e0e0;", placeholder="Comenta...", v-model="Comentario")
				.input-group-append
					button.btn.btn-sm.btn-primary(@click="comentar()", :disabled="!Comentario")
						span.fa.fa-send.mr-2
						| Comentar
</template>

<script>
import axios from 'axios'
export default {
	props: ['datos'],
	data () {
		return {
			verTodos: false,
			Comentario: null
		}
	},
	computed: {
		comentarios () {
			if (!this.datos.Comentarios) {
				return []
			}
			if (!this.verTodos) {
				return this.datos.Comentarios.slice(0, 3)
			} else {
				return this.datos.Comentarios
			}
		},
		hayMas () {
			if (!this.datos.Comentarios) {
				return false
			}
			return (!this.verTodos && this.datos.Comentarios.length > 3)
		}
	},
	methods: {
		comentar () {
			const datos = {
				PublicacionID: this.datos.PublicacionID,
				Comentario: this.Comentario
			}
			axios.post('muro/php/api/setComentario.php', datos)
				.then(res => {
					axios.get('muro/php/api/getPublicacion.php?PublicacionID=' + this.datos.PublicacionID)
						.then(res => {
							this.$store.dispatch('muro/actualizarPublicacion', this.datos.PublicacionID)
							this.verTodos = true
							this.Comentario = null
						})
						.catch(e => {
							console.error(e.response.data.error)
						})
				})
				.catch(e => {
					console.error(e.response.data.error)
				})
		}
	}
}
</script>


<style scoped>
.comentarios {
	position: relative;
	display: block;
	background-color: #f9f9f9;
}

.titular {
	font-size: 1.2em;
	opacity: 0.7;
	padding: 10px;
}
.comentario {
	position: relative;
	display: block;
	padding: 5px;
	margin: 0;
	border-top: 1px solid #e0e0e0;
	border-bottom: 0;
	background-color: #fefefe;
	color: #888888;
}

.cabecera {
	position: relative;
	display: flex;
	flex-direction: row;
}
.usuario {
	flex-grow: 1;
	flex-basis: 1;
	font-weight: bold;
}
.fecha {
	flex-grow: 1;
	flex-basis: 1;
	text-align: right;
}

.verTodos {
	padding: 5px;
	cursor: pointer;
}
.verTodos:hover {
	color: yellow;
}

.formulario {
	position: relative;
	display: flex;
	flex-direction: row;
}

.formulario > .input {
	position: relative;
	flex-grow: 1;
	flex-basis: 1;
	align-content: stretch;
	align-items: stretch;
	align-self: stretch;
}

.formulario > .enviar {
	position: relative;
	align-content: center;
	align-items: center;
	align-self: center;
	max-width:100px;
	padding: 10px;
}
</style>




// WEBPACK FOOTER //
// src/modulos/muro/vue/componentes/publicacion/comentarios.vue